import React from 'react';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';

import RegistrationForm from './registration-form';

export function RegistrationPage(props) {
    // If we are logged in (which happens automatically when registration
    // is successful) redirect to the user's dashboard
    if (props.loggedIn) {
        return <Redirect to="/intro" />;
    }
    const styles={"textAlign": "center"}
    return (
        <div style={styles} className="home">
            <h2>Please register here!</h2>
            <RegistrationForm />
            <Link className="loginbutton" to="/">Login</Link>
        </div>
    );
}

const mapStateToProps = state => ({
    loggedIn: state.auth.currentUser !== null
});

export default connect(mapStateToProps)(RegistrationPage);



// WEBPACK FOOTER //
// ./src/components/registration-page.js